export const deepSearch = (needle: string, haystack: Object, found: string[] = []) => {
  Object.keys(haystack).forEach((key: string) => {
    if (typeof haystack[key] === 'object') {
      deepSearch(needle.toLowerCase(), haystack[key], found);
    } else if (typeof haystack[key] === 'string' || typeof haystack[key] === 'number') {
      if (
        haystack[key]
          .toString()
          .toLowerCase()
          .indexOf(needle.toLowerCase()) > -1
      ) {
        found.push(haystack[key]);
      }
      return found;
    }
    return;
  });
  return found;
};



// WEBPACK FOOTER //
// ./src/common/utils.ts